/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { relationshipTypeIdGet } from '../fn/relationship-type/relationship-type-id-get';
import { RelationshipTypeIdGet$Params } from '../fn/relationship-type/relationship-type-id-get';
import { RelationshipTypeModel } from '../models/relationship-type-model';
import { RelationshipTypeModelSearchResultModel } from '../models/relationship-type-model-search-result-model';
import { relationshipTypePost } from '../fn/relationship-type/relationship-type-post';
import { RelationshipTypePost$Params } from '../fn/relationship-type/relationship-type-post';
import { relationshipTypeSearchRelationshipTypePost } from '../fn/relationship-type/relationship-type-search-relationship-type-post';
import { RelationshipTypeSearchRelationshipTypePost$Params } from '../fn/relationship-type/relationship-type-search-relationship-type-post';

@Injectable({ providedIn: 'root' })
export class MDIRelationshipTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `relationshipTypeSearchRelationshipTypePost()` */
  static readonly RelationshipTypeSearchRelationshipTypePostPath = '/RelationshipType/SearchRelationshipType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `relationshipTypeSearchRelationshipTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  relationshipTypeSearchRelationshipTypePost$Response(params?: RelationshipTypeSearchRelationshipTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<RelationshipTypeModelSearchResultModel>> {
    return relationshipTypeSearchRelationshipTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `relationshipTypeSearchRelationshipTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  relationshipTypeSearchRelationshipTypePost(params?: RelationshipTypeSearchRelationshipTypePost$Params, context?: HttpContext): Observable<RelationshipTypeModelSearchResultModel> {
    return this.relationshipTypeSearchRelationshipTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<RelationshipTypeModelSearchResultModel>): RelationshipTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `relationshipTypeIdGet()` */
  static readonly RelationshipTypeIdGetPath = '/RelationshipType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `relationshipTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  relationshipTypeIdGet$Response(params: RelationshipTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<RelationshipTypeModel>> {
    return relationshipTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `relationshipTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  relationshipTypeIdGet(params: RelationshipTypeIdGet$Params, context?: HttpContext): Observable<RelationshipTypeModel> {
    return this.relationshipTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<RelationshipTypeModel>): RelationshipTypeModel => r.body)
    );
  }

  /** Path part for operation `relationshipTypePost()` */
  static readonly RelationshipTypePostPath = '/RelationshipType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `relationshipTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  relationshipTypePost$Response(params?: RelationshipTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return relationshipTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `relationshipTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  relationshipTypePost(params?: RelationshipTypePost$Params, context?: HttpContext): Observable<string> {
    return this.relationshipTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
